import { PercentFormatter, StringUtil } from '@ddt-web/generic-utils';

declare const Highcharts;

/**
 * CurrencyAndPercentageTooltip: this tooltip includes both the currency value and the percentage change of the data point.
 */
export class CurrencyAndPercentageTooltip {
	public static getFormatter(multiplier: number = 10000, displayCurrency: string = '$'): any {
		return function (): string {
			let out = '';
			let setTooltipHeader = true;
			out += '<div class="performance-tooltip-container">';
			this.points.forEach(point => {
				if (setTooltipHeader) {
					out += '<h4 class="performance-tooltip-header">' + Highcharts.dateFormat('%a, %b %e, %Y', this.x) + '</h4>';
					setTooltipHeader = false;
				}

				const seriesColor = point.series.color;
				const valueAsPercentChanged = new PercentFormatter(2).format((point.y - multiplier) / multiplier, true);
				out += '<div class="performance-tooltip">' + '<table>';
				out +=
					'<tr>' +
					// name cell
					'<td colspan="2"><div class="portfolio-icon" style="background-color:' + StringUtil.escapeHtml(seriesColor) +
					';border-radius:50%; width:10px; height:10px; display:inline-block; margin-right:2px;"></div>' +
					StringUtil.escapeHtmlWithChartLineBreaks(StringUtil.splitSpaceLessStringForChart(point.point.series.name, 50, true)) +
					'</td>' +
					'</tr>' +
					'<tr>' +
					// $ val cell
					'<td class="dollar-value">' +
					StringUtil.escapeHtml(displayCurrency) +
					StringUtil.escapeHtml(Highcharts.numberFormat(point.y, 2, '.', ',')) +
					'</td>' +
					// % change
					'<td class="percent-value">' +
					StringUtil.escapeHtml(valueAsPercentChanged) +
					'</td>' +
					'</tr>';
				out += '</table></div>';
			});
			out += '</div>';
			return out;
		};
	}
}
